import PropTypes from 'prop-types'
import React from 'react'
import SimpleReactModal from 'simple-react-modal'

import SvgIcon from 'components/common/SvgIcon'

import { fullName } from 'src/services/user_helpers'

import CheckMark from 'src/assets/icons/hud_checkmark.svg'
import HudError from 'src/assets/hud_error.svg'
import PaperAirplane from 'src/assets/icons/hud_paper_airplane.svg'

import styles from './hobnob-hud.scss'

export default class HobnobHud extends React.Component {
  _renderIcon () {
    switch (this.props.type) {
      case 'success':
        return CheckMark
      case 'sent':
        return PaperAirplane
      case 'error':
        return HudError
      default:
        return HudError
    }
  }

  _formattedMessage () {
    let { host, message } = this.props
    message = message.replace('{host_name}', fullName(host))
    return message
  }

  render () {
    const { onClose, show } = this.props
    const containerStyles = {
      padding: '30vh 0 0 0',
      background: 'transparent',
      margin: '0 auto',
      width: '220px',
      textAlign: 'center'
    }
    // Keep in sync with HobnobModal
    const style = {
      transition: 'opacity 0.25s ease-in-out',
      fontFamily: null
    }

    return (
      <SimpleReactModal
        show={show}
        onClose={onClose}
        closeOnOuterClick
        style={style}
        containerStyle={containerStyles}
        transitionSpeed={250}
      >
        <div className={styles['container']}>
          <SvgIcon icon={this._renderIcon()} />
          <div className={styles['message']}>
            {this._formattedMessage()}
          </div>
        </div>
      </SimpleReactModal>
    )
  }
}

HobnobHud.defaultProps = {
  host: {}
}

HobnobHud.propTypes = {
  show: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  host: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/common/HobnobHud.jsx